import {useState, useEffect} from 'react'

export default function useServices(service: any, param?: any, initData?: any) {
  const [data, setData] = useState(initData || [])
  const [loading, setLoading] = useState(true)
  const [isError, setIsError] = useState(false)
  const [refreshCounter, setRefreshCounter] = useState(1)

  useEffect(() => {
    const controller = new AbortController()

    async function getData() {
      try {
        setLoading(true)
        const newData = await service(param, {signal: controller.signal})
        setData(newData)
        setIsError(false)
        setLoading(false)
      } catch (error: any) {
        if (error.message !== 'canceled') {
          setLoading(false)
          setIsError(true)
        }
      }
    }

    getData()

    return () => {
      controller.abort()
    }
  }, [service, refreshCounter])

  const triggerRefresh = () => {
    setRefreshCounter((value) => value + 1)
  }

  const makeItEmpty = () => setData(initData || [])

  return [data, loading, makeItEmpty, triggerRefresh, isError, setLoading]
}
